import { render, staticRenderFns } from "./CourseTag.vue?vue&type=template&id=2c58a93c&scoped=true"
import script from "./CourseTag.vue?vue&type=script&lang=js"
export * from "./CourseTag.vue?vue&type=script&lang=js"
import style0 from "./CourseTag.vue?vue&type=style&index=0&id=2c58a93c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c58a93c",
  null
  
)

export default component.exports